import styled from 'styled-components';
import { Box } from '@interstate/components/Box';
import { rem } from 'polished';
import { Typography } from '@interstate/components/Typography';

export const SlideoutContainer = styled(Box)`
    && {
        display: flex;
        flex-direction: column;
        height: 100%;
        max-width: 650px;
    }
`;

export const Subheader = styled(Typography)`
    && {
        font-size: ${rem(14)};
        color: ${({ theme }) => theme.tokens.ColorOnSurfaceSubdued};
        margin-bottom: ${rem(20)};
        line-height: 1.5;
    }
`;

export const SlideoutBody = styled(Box)`
    && {
        flex: 1 1 auto;
        display: flex;
        flex-direction: column;
        gap: ${rem(24)};
        padding-bottom: ${rem(120)};
    }
`;

export const MetricRowsContainer = styled(Box)`
    && {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: ${rem(16)};
        padding-top: ${rem(16)};
    }
`;

export const MonthlyPaymentText = styled(Typography)`
    && {
        color: ${({ theme }) => theme.tokens.SemColorOnSurfaceMuted};
        text-transform: uppercase;
        font-size: ${rem(11)};
        display: block;
    }
`;

export const MonthlyPaymentValue = styled(Typography)`
    && {
        color: ${({ theme }) => theme.tokens.SemColorSurfaceButtonPrimaryRest};
        font-size: ${rem(30)};
        display: block;
    }
`;

export const MonthlyPaymentPeriod = styled(Typography)`
    && {
        color: ${({ theme }) => theme.tokens.SemColorOnSurfaceMuted};
    }
`;
